module.exports = __webpack_public_path__ + "img/clip-climb.07087fd9.webp";